import React, { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import { Dimmer, Loader, Pagination } from "semantic-ui-react";
import OrderModel from "../../admin/components/order/order.model";
import Sidebar from "../../layouts/main/sidebar";
import store from "../../store";
import { formatDateTime } from "../../utils/shared.utils";
import "./client.orders.scss";
import OrderDetailsComponent from "./orders-details.component";

const bucket = process.env.REACT_APP_S3_BUCKET;
const region = process.env.REACT_APP_S3_REGION;

function ClientOrdersPage(props: any) {
  const history = useHistory();
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [fetchedOrders, setFetchedOrders] = useState(false);
  const [page, setPage] = useState({ page: 1, size: 10, totalPages: 1 });

  const [visible, setVisible] = useState(true);

  const toggle = (index: number) => {
    const updatedOrders = [...orders];
    updatedOrders.forEach((o, i) => {
      o.showItems = i === index;
    });
    setOrders(updatedOrders);
    setVisible(false);
  };

  useEffect(() => {
    if (fetchedOrders) {
      return;
    }
    setFetchedOrders(true);
    getClientOrders(1);
    window.scrollTo(0, 0);
  }, []);

  const getClientOrders = (pageNum: number) => {
    var token = localStorage.getItem("clientToken");
    if (token && token !== "undefined") {
      setLoading(true);
      fetch(process.env.REACT_APP_API_URL + "client/orders", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ page: { page: pageNum, size: page.size } }),
      })
        .then((res: any) => {
          setLoading(false);
          if (res.ok) {
            res.json().then((resJson: any) => {
              let orders: OrderModel[] = resJson.data;
              for (let order of orders) {
                order.showItems = false;
                order.createdAt = new Date(order.createdAt);
                order.createdAtStr = formatDateTime(order.createdAt);
                for (let delivery of order.deliveries) {
                  let date = new Date(delivery.date);
                  delivery.date = `${date.getMonth() + 1
                    } сарын ${date.getUTCDate()}`;
                  for (let item of delivery.items) {
                    item.product.imageXsUrl = `https://${bucket}.s3.${region}.amazonaws.com/${item.product.imageXsUrl}`;
                  }
                }
              }
              setOrders(orders);
              setPage(resJson.page);
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg("Сүлжээний алдаа");
          console.error(err);
        });
    } else {
      console.debug("Will redirect to: " + window.location.pathname);
      store.dispatch({ type: "redirectUrl", data: window.location.pathname });
      history.push("/login");
    }
  };

  const onPageChange = (event: any, data: any) => {
    setPage(Object.assign(page, { page: data.activePage }));
    getClientOrders(data.activePage);
    window.scrollTo(0, 100);
  };

  const logout = () => {
    localStorage.removeItem("clientToken");
    store.dispatch({ type: "logout" });
    history.push("/login");
  };

  const closeMenu = () => { };

  return (
    <div className="page page-client-orders margin-top-50-sm">
      <div className="client-layout">
        <Dimmer active={loading}>
          <Loader size="medium"></Loader>
        </Dimmer>
        <Sidebar onLogout={logout} closeMenu={closeMenu} />
        <section className="client-orders" id="my-form">
          <div className="client-head">
            {!visible && (
              <IoArrowBack
                size={28}
                onClick={() => {
                  const resetOrders = orders.map((order) => ({
                    ...order,
                    showItems: false,
                  }));
                  setOrders(resetOrders);
                  setVisible(true);
                }}
                color="gray"
              />
            )}
            <h2 style={{ color: visible ? "black" : "gray" }}>
              Миний захиалгууд
            </h2>
          </div>

          <div className="errorMsg">{errorMsg}</div>

          {orders?.length > 0 ? (
            <React.Fragment>
              <OrderDetailsComponent
                orders={orders}
                showStaff={false}
                onToggle={toggle}
                visible={visible}
                setVisible={setVisible}
              />

              <div className="flex-div margin-top-50">
                <Pagination
                  defaultActivePage={1}
                  value={page.page}
                  totalPages={page.totalPages}
                  onPageChange={onPageChange}
                ></Pagination>
              </div>
            </React.Fragment>
          ) : (
            <div>Танд захиалга байхгүй байна.</div>
          )}
        </section>
      </div>
    </div>
  );
}
export default ClientOrdersPage;
